import { Checkbox, FormControl, FormControlLabel, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { memo } from "react";
const useStyle = makeStyles({
  fontDB: {
    fontFamily: "DB Heavent !important",
  },
  fontNormal: {
    fontWeight: "normal !important",
  },
});
const CheckboxComponent = (props) => {
  const classes = useStyle();
  const { choice, suitJson, handleChange } = props;
  const qu = suitJson?.SAfsac_Answer.toString().split("_");
  return (
    <Grid className="pb-4">
      <FormControl style={{ width: "100%" }}>
        {choice.map((row, i) => (
          <FormControlLabel
            key={i}
            onChange={(e) => handleChange(e, row?.ChoiceID)}
            classes={{
              label: clsx(
                classes.fontDB,
                "text-black",
                classes.fontNormal,
                "font-20"
              ),
            }}
            className="b-bottom pl-3 pr-3"
            control={<Checkbox checked={qu.includes("" + (i + 1))} />}
            label={row?.Text}
          />
        ))}
      </FormControl>
    </Grid>
  );
};
export default memo(CheckboxComponent);
